import { axios as api } from '@/plugins/axios';

export class CategoryService {
  private categoryEndpoint: string;
  constructor(resource: string) {
    this.categoryEndpoint = `${resource}categories/`;
  }
  async fetchCategories(event: string) {
    return api
      .get(`${this.categoryEndpoint}?event=${event}`)
      .then(response => response.data);
  }
  async getCategory(id: number) {
    return api
      .get(`${this.categoryEndpoint}${id}/`)
      .then(response => response.data);
  }
  async createCategory(payload: object) {
    return api
      .post(`${this.categoryEndpoint}`, payload)
      .then(response => response.data);
  }
  async updateCategory(id: number, payload: object) {
    return api
      .patch(`${this.categoryEndpoint}${id}/`, payload)
      .then(res => res.data as Event);
  }
  async optionsCategory() {
    return api({ method: 'options', url: `${this.categoryEndpoint}` }).then(
      ({ data }) => data
    );
  }
  async optionCategory(id: number) {
    return api({
      method: 'options',
      url: `${this.categoryEndpoint}${id}/`
    }).then(({ data }) => data);
  }
  async deleteCategory(id: number) {
    return api.delete(`${this.categoryEndpoint}${id}/`);
  }
}
